var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileAdd = function SvgIconProfileAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_profile_add_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#C6C8CC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_profile_add_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 62.5,
    height: 62.5,
    rx: 31.25,
    stroke: "#242526",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 33.5a1.5 1.5 0 0 0 0-3H33.5V19a1.5 1.5 0 0 0-3 0v11.5H19.003a1.5 1.5 0 0 0 0 3H30.5v11.497a1.5 1.5 0 1 0 3 0V33.5H45Z",
    fill: "#A4A7AD"
  })));
};
export default SvgIconProfileAdd;